import { IComboBoxStyles } from "@fluentui/react/lib/ComboBox";
import { concatStyleSets, FontWeights } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { controlStylingConstants } from "@1js/acui-common";

export const getComboBoxStylesInMenu = memoizeFunction(
  (
    icon: string | undefined,
    customStyles?: Partial<IComboBoxStyles>
  ): Partial<IComboBoxStyles> => {
    return concatStyleSets(
      {
        container: {
          margin: 0,
        },
        root: {
          marginRight: controlStylingConstants.menuItemGapToRightEdge,
        },
        label: {
          marginLeft: !icon
            ? controlStylingConstants.menuNoIconGutterPadding
            : undefined,
          fontWeight: FontWeights.regular,
        },
      },
      customStyles
    );
  }
);

export const getComboBoxStylesInMLRMenu = memoizeFunction(
  (customStyles?: Partial<IComboBoxStyles>): Partial<IComboBoxStyles> => {
    return concatStyleSets(
      {
        label: {
          fontSize: 12,
          marginLeft: 36,
        },
      },
      customStyles
    );
  }
);
